<template>
    <div>
        <span class="icon"><img src="@/assets/images/icon-tel.png"></span><a class="phone" href="tel:18611838798">+86 18611838798</a><br>
        <span class="icon"><img src="@/assets/images/icon-email.png"></span>info@xidespace.com<br>
        <span class="icon"><img src="@/assets/images/icon-location.png"></span>北京市朝阳区燕莎中心写字楼五层C516室 
    </div> 
</template>
<script>
    
export default {
    name: 'BaseAddress',
    props: {
        text: Object
    },
    data: function () {
      return {

      }
    },
    updated: function () {

    },
    mounted() {
        
    }
}
</script>

<style scoped>
    .phone {
        text-decoration: underline;
    }
</style>
